import { IconCross } from "@/components/header/icon-cross"
import { IconEmail } from "@/components/header/icon-email"
import { IconHamburger } from "@/components/header/icon-hamburger"
import { NavItem } from "@/components/header/nav-item"
import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router"

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 100)
  }

  const handleResize = () => {
    window.innerWidth > 767 && setIsMenuOpen(false)
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    setIsMenuOpen(false)
  }, [location])

  return (
    <>
      <header
        className={`
          w-full
          fixed top-0 left-0 z-[999]
          flex justify-between items-center
          gap-4 md:gap-0
          py-[18px] px-6 md:py-[18px] md:px-[5.55%]
          ${isMenuOpen ? " !bg-opacity-100 bg-white" : ""}
          ${isScrolled ? " bg-opacity-80 bg-white" : ""}
        `}
      >
        <Link to="/">
          <h1 className="w-[109px] md:w-[12.84dvw] mr-24">
            <img src="/images/common/logo_kotaeru.svg" alt="コタエルHR" />
          </h1>
        </Link>

        <div className="hidden md:flex md:justify-end w-full">
          <ReusableNavs />
        </div>

        <div className="flex md:hidden relative">
          <button
            type="button"
            aria-label={isMenuOpen ? "閉じる" : "メニュー"}
            className={`
              flex place-items-center gap-x-2
              text-[12px] font-bold leading-[1]
              ${isMenuOpen ? "text-theme-main" : ""}
            `}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <>
                <IconCross />
                閉じる
              </>
            ) : (
              <>
                <IconHamburger />
                メニュー
              </>
            )}
          </button>
        </div>
      </header>

      {/* ▼モバイル版でボタン押下後に表示されるメニュー */}
      <div
        data-testid="mobile-menu"
        className={`
          ${isMenuOpen ? "block" : "hidden"}
          fixed top-[59px] left-0 z-[999]
          py-[30px] px-12
          w-full h-fit
          bg-white
          border-t-[1px] border-main
        `}
      >
        <ReusableNavs direction="col" />
      </div>

      {/* ▼モバイル版でボタン押下後に表示されるメニューの背後の影部分(backdrop) */}
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: */}
      <div
        className={`
          ${isMenuOpen ? "block" : "hidden"}
          fixed top-0 left-0 w-dvw h-dvh z-10
          transition-all duration-300
          backdrop-brightness-95
          backdrop-blur-[2px]
        `}
        onClick={() => setIsMenuOpen(false)}
      />
    </>
  )
}

const ReusableNavs = ({ direction = "row" }: { direction?: "row" | "col" }) => (
  <nav className="w-full">
    <ul
      className={`
        flex flex-${direction}
        justify-end
        gap-6 md:gap-[4%]
        p-0 w-full
      `}
    >
      <NavItem to="/about" title="私たちについて" titleEnglish="About us" />
      <NavItem to="/service" title="サービス" titleEnglish="Service" />
      <NavItem to="/news" title="ニュース" titleEnglish="News" />
      <NavItem to="/recruit" title="採用情報" titleEnglish="Recruit" />
      <li>
        <a
          href="https://share.hsforms.com/1HGVjUue-TECLD2HOytVUcwdwtzz"
          className={`
            flex place-content-center
            gap-x-3
            md:w-[154px]
            px-3.5 py-4
            font-bold
            border border-theme-sub
            md:hover:bg-theme-main
            md:hover:text-other-main
            md:hover:border-theme-main

            [&_svg]:translate-y-[1px]
            [&_svg]:fill-theme-sub
            md:[&_svg]:hover:fill-other-main
          `}
        >
          <span className="inline-block leading-[1]">お問い合わせ</span>
          {<IconEmail />}
        </a>
      </li>
    </ul>
  </nav>
)
